import { deleteRequest, fetchRequest, patchRequest, postRequest } from 'services/api.service';

export async function fetchLead(leadId: string) {
  return fetchRequest(`/leads/${leadId}`);
}

export async function fetchConversation(leadId: string) {
  return fetchRequest(`/leads/${leadId}/conversation`);
}

export async function fetchMessage(messageId: number) {
  return fetchRequest(`/messages/${encodeURIComponent(messageId)}`);
}

export async function fetchMessageMedia(messageId: number) {
  return fetchRequest(`/messages/${messageId}/media`);
}

export async function fetchMessageMediaData(messageId: number, index: number) {
  return fetchRequest(`/messages/${messageId}/media/${index}`);
}

export async function createScheduledFollowUp(leadId: string, payload: any) {
  return postRequest('/messages/schedule', { leadId, ...payload });
}

export async function deleteScheduledFollowUp(leadId: string) {
  return deleteRequest(`/leads/${leadId}/scheduled-follow-up`);
}

export async function escalateLead(leadId: string) {
  return postRequest(`/leads/${leadId}/escalate`);
}

export async function invalidateLead(leadId: string, payload: any) {
  return postRequest(`/leads/${leadId}/invalidate`, payload);
}

export async function invalidPhoneLead(leadId: string, payload: any) {
  return postRequest(`/leads/${leadId}/invalid-phone`, payload);
}

export async function markLeadAsDone(leadId: string) {
  return postRequest(`/leads/${leadId}/done`);
}

export async function noResponseNeededLead(leadId: string) {
  return postRequest(`/leads/${leadId}/no-response`);
}

export async function patchLead(leadId: string, payload: any) {
  return patchRequest(`/leads/${leadId}`, payload);
}

export async function qualifyLead(leadId: string, payload: any) {
  return postRequest(`/leads/${leadId}/qualify`, payload);
}

export async function reopenLead(leadId: string, payload: any) {
  return postRequest(`/leads/${leadId}/reopen`, payload);
}

export async function stopContactLead(leadId: string) {
  return postRequest(`/leads/${leadId}/stop-contact`);
}

export async function unqualifyLead(leadId: string, payload: any) {
  return postRequest(`/leads/${leadId}/unqualify`, payload);
}

export async function fetchMessageTemplates(leadId: string) {
  return fetchRequest(`/message-templates?leadId=${leadId}`);
}

export async function fetchAiPrompts(leadId: string) {
  return fetchRequest(`/ai-prompts?leadId=${leadId}`);
}

export async function runAiPrompt(aiPromptId: string, leadId: string) {
  return postRequest(`/ai-prompts/${aiPromptId}/run`, { leadId });
}
